import type {RGBA} from '@Utils/color.util';

export enum FillTypes {
  SOLID = 0,
  LINEAR_GRADIENT = 1,
  RADIAL_GRADIENT = 2,
  NONE = 3,
}

export interface FillObject {
  fillType: FillTypes;
  fillColor: RGBA[];
}

export const DEFAULT_FILL_COLOR: RGBA = [0, 0, 0, 1];
